// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import ChatWidget from "../ChatWidget"
import Header from "../Header"
import Footer, { SocialProps } from "../Footer"
import SEO from "../SEO"
import "./styles.scss"

interface Props {
  className?: string
  title: string
  children?: any
  seoImage?: string
}

const Layout: React.FC<Props> = ({ className, title, seoImage, children }: Props) => {
  const { site } = useStaticQuery(query)
  const socialMetadata: SocialProps = site.siteMetadata.social

  return (
    <div className={className}>
      <SEO title={title} image={seoImage} />
      <Header />
      <main>{children}</main>
      <ChatWidget />
      <Footer {...socialMetadata} />
    </div>
  )
}

export default Layout

// jamie todo: let's pull this query into a hook
const query = graphql`
  query {
    site {
      siteMetadata {
        social {
          companyLinkedinHandle
          twitterHandle
          githubHandle
        }
      }
    }
  }
`
